var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 43,
    viewBox: "0 0 47 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5772 21.3047L38.247 32.7909C38.8206 33.3109 38.8206 34.154 38.247 34.674C37.6734 35.194 36.7435 35.194 36.1699 34.674L23.5001 23.1878L10.8303 34.674C10.2567 35.194 9.32671 35.194 8.75313 34.674C8.17954 34.154 8.17954 33.3109 8.75313 32.7909L21.4229 21.3047L8.75313 9.8185C8.17954 9.2985 8.17954 8.45541 8.75313 7.93541C9.32671 7.41541 10.2567 7.41541 10.8303 7.93541L23.5001 19.4216L36.1699 7.93541C36.7435 7.41541 37.6734 7.41541 38.247 7.93541C38.8206 8.45541 38.8206 9.2985 38.247 9.8185L25.5772 21.3047Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/CloseModal.9522a8035ad06fd06bf7c59f4d046f81.svg";
export { ForwardRef as ReactComponent };